import { fg } from '@atlaskit/platform-feature-flags';

import type { EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForConfluenceEndUserRequestExperiment(
	context: EditionAwarenessContextType,
): boolean {
	const { product, edition, hasPaymentDetailsEntered, isInCollection, canUpgrade } = context;

	return Boolean(
		!isInCollection &&
			product === 'confluence' &&
			edition === 'free' &&
			hasPaymentDetailsEntered === true &&
			canUpgrade === false &&
			(fg('connie_end_user_request_ea_vc90_check') || fg('connie_end_user_request_kill_switch')),
	);
}
